var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05D9\u05D9\u05E6\u05D5\u05E8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u05D9\\u05D9\\u05E6\\u05D5\\u05E8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-copy",
    transform: "translate(6.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0091FF",
    points: "38.9284309 11.2997696 38.9263564 33.533096 19.4636968 45 19.4636968 22.531106 38.9263564 11.2987327"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B4D2D7",
    points: "19.4636968 22.531106 9.54151596 16.8044931 29.0031383 5.57108295 29.0041755 5.57108295 38.9263564 11.2987327"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E1EBF0",
    points: "29.0031383 5.57108295 9.54151596 16.8044931 0.00207446809 11.2987327 19.4636968 0.0653225806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0374CA",
    points: "19.4636968 22.531106 19.4636968 45 0 33.7665899 0 11.2997696 0.00207446809 11.2987327 9.54151596 16.8044931"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.a3ce8df5d9772f4fae72808111a61c85.svg";
export { ForwardRef as ReactComponent };